import axios from "axios";
import { BehaviorSubject } from "rxjs";
import environment from "../../config/environment";

const authSubject = new BehaviorSubject(null);

export function signin(token) {
  authSubject.next(token);
  authSubject.subscribe((res) => {
    window.tokenData = res;
  });
}

const http = axios.create({
  baseURL: environment.apiUrl,
  headers: {
    "Content-type": "application/json; charset=utf-8",
  },
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

export default http;